// saga.js

import { takeLatest, put, call } from "redux-saga/effects"; // Import necessary functions from Redux Saga
import { FAVOURITE } from "../../../utility/constants"; // Import constant for API endpoint
import axios from "axios"; // Import Axios for making HTTP requests
import {
  FETCH_MYLIST_REQUEST, // Import action type for fetching user's favorite items
  fetchMyListSuccess, // Import action creator for successful fetch
  fetchMyListFailure, // Import action creator for fetch failure
} from "../../actions/mylistActions/viewmylistAction"; // Import action creators for success and failure cases

// Saga function to fetch user's favorite items
function* fetchMyListview(action) {
  try {
    // Make GET request to the FAVOURITE endpoint
    const response = yield call(axios.get, FAVOURITE, {
      // Include token from local storage in the request headers
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    // Check if the response is successful and status is "Success"
    if (response.status === 200 && response.data.status === "Success") {
      // Dispatch action to handle successful fetch with response data
      yield put(fetchMyListSuccess(response.data));
      // Return favorite items from the response data
      return response.data.favourite;
    }
  } catch (error) {
    // Dispatch action to handle fetch failure with error message
    yield put(fetchMyListFailure(error.message));
  }
}

// Watcher saga to trigger the fetch user's favorite items request
export function* viewMyListSaga() {
  yield takeLatest(FETCH_MYLIST_REQUEST, fetchMyListview);
}

// Export the watcher saga function as default
export default viewMyListSaga;
